var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    enableBackground: "new 0 0 500 500",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F1BBBB",
    d: "M383.9,454.2H72.6c-27.5,0-50.5-21-53-48.3L5,246.8c-2.7-28.9,18.4-54.6,47.3-57.8l347.3-37.4 c33.8-3.6,62.3,24.9,58.6,58.7l-21.5,196.5C433.8,433.8,411,454.2,383.9,454.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#371515",
    d: "M287.2,453h-257l-14-224.1c-0.7-10.6,7.4-19.2,18-19.2h218.7c10.6,0,19.7,8.6,20.4,19.2L287.2,453z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DC5455",
    d: "M294.7,453h-257l-14-224.1c-0.7-10.6,7.4-19.2,18-19.2h218.7c10.6,0,19.7,8.6,20.4,19.2L294.7,453z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#371515",
    d: "M93.9,320.1H66.7c-2.9,0-5.4-2.3-5.5-5.2l-1.7-27.2c-0.2-2.9,2-5.2,4.9-5.2h27.2c2.9,0,5.4,2.3,5.5,5.2 l1.7,27.2C99,317.7,96.8,320.1,93.9,320.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M77.9,310c-0.6,0-1.2-0.2-1.6-0.7l-6.7-6.7c-0.9-0.9-0.9-2.3,0-3.2s2.3-0.9,3.2,0l4.6,4.6l7.5-13.1 c0.6-1.1,2-1.4,3-0.8c1.1,0.6,1.4,2,0.8,3l-8.9,15.6c-0.3,0.6-1,1-1.6,1.1C78.1,310,78,310,77.9,310z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F1BBBB",
    d: "M146.2,320.1H119c-2.9,0-5.4-2.3-5.5-5.2l-1.7-27.2c-0.2-2.9,2-5.2,4.9-5.2h27.2c2.9,0,5.4,2.3,5.5,5.2 l1.7,27.2C151.2,317.7,149,320.1,146.2,320.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F1BBBB",
    d: "M198.4,320.1h-27.2c-2.9,0-5.4-2.3-5.5-5.2l-1.7-27.2c-0.2-2.9,2-5.2,4.9-5.2h27.2c2.9,0,5.4,2.3,5.5,5.2 l1.7,27.2C203.5,317.7,201.3,320.1,198.4,320.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M250.7,320.1h-27.2c-2.9,0-5.4-2.3-5.5-5.2l-1.7-27.2c-0.2-2.9,2-5.2,4.9-5.2h27.2c2.9,0,5.4,2.3,5.5,5.2 l1.7,27.2C255.7,317.7,253.5,320.1,250.7,320.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#371515",
    d: "M97,369H69.8c-2.9,0-5.4-2.3-5.5-5.2l-1.7-27.2c-0.2-2.9,2-5.2,4.9-5.2h27.2c2.9,0,5.4,2.3,5.5,5.2 l1.7,27.2C102,366.6,99.9,369,97,369z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M149.2,369H122c-2.9,0-5.4-2.3-5.5-5.2l-1.7-27.2c-0.2-2.9,2-5.2,4.9-5.2h27.2c2.9,0,5.4,2.3,5.5,5.2 l1.7,27.2C154.3,366.6,152.1,369,149.2,369z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F1BBBB",
    d: "M201.5,369h-27.2c-2.9,0-5.4-2.3-5.5-5.2l-1.7-27.2c-0.2-2.9,2-5.2,4.9-5.2h27.2c2.9,0,5.4,2.3,5.5,5.2 l1.7,27.2C206.5,366.6,204.3,369,201.5,369z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M185.3,359.7c-0.6,0-1.2-0.2-1.6-0.7l-6.7-6.7c-0.9-0.9-0.9-2.3,0-3.2c0.9-0.9,2.3-0.9,3.2,0l4.6,4.6 l7.5-13.1c0.6-1.1,2-1.4,3-0.8c1.1,0.6,1.4,2,0.8,3l-8.9,15.6c-0.3,0.6-1,1-1.6,1.1C185.5,359.7,185.4,359.7,185.3,359.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F1BBBB",
    d: "M253.7,369h-27.2c-2.9,0-5.4-2.3-5.5-5.2l-1.7-27.2c-0.2-2.9,2-5.2,4.9-5.2h27.2c2.9,0,5.4,2.3,5.5,5.2 l1.7,27.2C258.8,366.6,256.6,369,253.7,369z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#371515",
    d: "M99.9,415.4H72.7c-2.9,0-5.4-2.3-5.5-5.2L65.5,383c-0.2-2.9,2-5.2,4.9-5.2h27.2c2.9,0,5.4,2.3,5.5,5.2 l1.7,27.2C104.9,413,102.8,415.4,99.9,415.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F1BBBB",
    d: "M152.1,415.4h-27.2c-2.9,0-5.4-2.3-5.5-5.2l-1.7-27.2c-0.2-2.9,2-5.2,4.9-5.2h27.2c2.9,0,5.4,2.3,5.5,5.2 l1.7,27.2C157.2,413,155,415.4,152.1,415.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M204.4,415.4h-27.2c-2.9,0-5.4-2.3-5.5-5.2l-1.7-27.2c-0.2-2.9,2-5.2,4.9-5.2H202c2.9,0,5.4,2.3,5.5,5.2 l1.7,27.2C209.4,413,207.2,415.4,204.4,415.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F1BBBB",
    d: "M256.6,415.4h-27.2c-2.9,0-5.4-2.3-5.5-5.2l-1.7-27.2c-0.2-2.9,2-5.2,4.9-5.2h27.2c2.9,0,5.4,2.3,5.5,5.2 l1.7,27.2C261.7,413,259.5,415.4,256.6,415.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#371515",
    d: "M280.7,228.9c-0.7-10.6-9.8-19.2-20.4-19.2H41.7c-10.6,0-18.7,8.6-18,19.2l1.9,31h257L280.7,228.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M289.7,452.9l55.4,0.4l-3.8-28l-27.6-1.5v6.3l-7.8,0.8c-9.6,1-16.8,9.3-16.3,19L289.7,452.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M469.2,437.3l30.8-50.5l-28.5-8.6l-16.6,26.6l6.9,1.3l-3,5.9c-4.2,8.7-0.8,19.2,7.7,23.8L469.2,437.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#371515",
    d: "M481.5,374l-26.3,41.4c-72.7-42.6-102.8-100.3-102-157.2l51.9-20.8C405,296.3,442.6,332.6,481.5,374z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#371515",
    d: "M352.6,429.1l-44.3-0.5c-10.9-74.7-8.6-137.5,13-178.8l56.2,10.1C357.9,305.8,347,364.4,352.6,429.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M312.3,156c0,0-10.8,5.2-18.6,28.5c-7.7,23.1-19.3,48.7-19.3,48.7s9.2,27.1,29,10.5S332.2,151.2,312.3,156 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DC5455",
    d: "M330.1,142.3c0,0-19.2,6.4-21.9,19.9c-3,14.9-0.2,49,8.3,97.2c0.1,11.6,99.8-2.5,97.4-18.7 c-20-41.7-19.5-89.8-33.2-99.1c-9.5-6.5-25.8-5.6-25.8-5.6S337.4,146.9,330.1,142.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFC3B0",
    d: "M225.2,279.9l6.9-3.7c0,0,4.5,10.7,12.7,10.7c7.6,0,19.7-14.8,19.7-14.8l-16.4-14.8l-26.5,16.4 c-1.5,1-2.1,2.9-1.3,4.6v0C221.2,280.2,223.4,280.9,225.2,279.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M263.3,276.2l-22.6-16.3l54.2-51.5c0,0,24.8,8.9,13.9,29.5C299.9,255,263.3,276.2,263.3,276.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFC3B0",
    d: "M402.1,234.4c-7.7,5.1-20.7,15.1-24.6,18.6c0,0,1.6,5.1,10.4-1.3s13.1-10.5,13.1-10.5L402.1,234.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFC3B0",
    d: "M387.6,249.9c0,0-4.8,13.2-2.7,16.1c2.1,2.9,5.2,0.9,6.4-2.3c1.1-2.8,5.1-20.2,5.1-20.2L387.6,249.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFC3B0",
    d: "M397,240c0,0-7.1,27.3-5,30.2c2.1,2.9,4.1,0.7,5.3-2.5c1.1-2.8,8.2-24.5,8.2-24.5L397,240z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFC3B0",
    d: "M401,236.2c0,0-4.4,27.8-2,30.5c2.4,2.7,4.1,0.3,5-3c0.8-2.9,5.8-25.2,5.8-25.2L401,236.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFC3B0",
    d: "M403.9,233c0,0-4.4,27.8-2,30.5c2.4,2.7,4.1,0.3,5-3c0.8-2.9,5.8-25.2,5.8-25.2L403.9,233z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M401.9,187.4c-6.4-10.8-40.1-26.5-35.8-38.7c6.8-19,49.7-1,67,22.3C439.1,189.7,419.4,205.4,401.9,187.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M394,238.7c0,0,13.8-90.2,37.4-69.5c15.1,13.3-15.3,70.7-15.3,70.7L394,238.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFC3B0",
    d: "M329.7,132.8l1.9,8.2c0,0-8.8,5.6-1.2,8.5c8.8,3.4,23.9-4.6,24.9-13.1l-3.9-0.8l-2.9-21.3L329.7,132.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#371515",
    d: "M328.7,134.3c0,0,2.6,5.8,10,4.1c7.3-1.7,11.6-22,11.6-22L328.7,134.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#371515",
    d: "M359.8,62.9c12,16.3-3.7,47.5-3.7,47.5l-65.2-5.1c-11.8-12.9-25.4-26.3-12.6-32.6c0,0-8.2-2-4.7-9.2 C278.6,53.3,344.8,42.5,359.8,62.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFC3B0",
    d: "M348.1,97.1c0,0,6.9-7.8,13.8-2.2s1.6,14.5-1.4,17c-2.4,2-9.6,3.1-9.6,3.1L348.1,97.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#371515",
    d: "M351.2,103.1c0,0,4.3-6.9,7.9-4c3.6,2.9,0.7,7.4-0.7,8.9c-2.2,2.3-7.3,1.2-7.3,1.2L351.2,103.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFC3B0",
    d: "M353,115.4c0-14.1-4.1-22.8-10.6-37.9c-40.3,26.2-59.1-1.6-58.3,14.3c0,0,1.5,34.7,16.6,43.1 c12,6.6,23.8,6.6,30.5,3.6C346.6,131.6,353,115.4,353,115.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#371515",
    d: "M334.4,72.3c-3.3,15.2,2,21.5,17,20.7l-4.7-21.5L334.4,72.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.2,
    y: 451.7,
    fill: "#371515",
    width: 490.3,
    height: 3.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#371515",
    d: "M348.9,60.2c-4.8-11.4-38.6-20.8-41.8-12.3c-2.6,6.8,16.4,6.8,19.3,13.7S348.9,60.2,348.9,60.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 458.3,
    cy: 319.5,
    r: 3.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#DC5455",
    cx: 150.5,
    cy: 172.1,
    r: 23.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 150.5,
    cy: 172.1,
    r: 18.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DC5455",
    d: "M149.2,177.1L149.2,177.1c-1.4,0-2.5-1.1-2.5-2.5v-13.8c0-1.4,1.1-2.5,2.5-2.5h0c1.4,0,2.5,1.1,2.5,2.5 v13.8C151.7,176,150.6,177.1,149.2,177.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DC5455",
    d: "M161.7,174.6L161.7,174.6c0,1.4-1.1,2.5-2.5,2.5h-10c-1.4,0-2.5-1.1-2.5-2.5v0c0-1.4,1.1-2.5,2.5-2.5h10 C160.6,172.1,161.7,173.2,161.7,174.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M138,146.2L138,146.2c-1.3,0.6-2.7,0-3.3-1.3l-2-4.6c-0.6-1.3,0-2.7,1.3-3.3l0,0c1.3-0.6,2.7,0,3.3,1.3 l2,4.6C139.8,144.2,139.2,145.7,138,146.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M125.3,156.3L125.3,156.3c-0.7,1.2-2.2,1.6-3.4,0.9l-4.4-2.5c-1.2-0.7-1.6-2.2-0.9-3.4h0 c0.7-1.2,2.2-1.6,3.4-0.9l4.4,2.5C125.5,153.6,126,155.1,125.3,156.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M77.6,231.1L77.6,231.1c-3.8,0-7.2-3.1-7.6-6.9l-2-20.1c-0.4-3.8,2.4-6.9,6.2-6.9h0c3.8,0,7.2,3.1,7.6,6.9 l2,20.1C84.2,228,81.4,231.1,77.6,231.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M127.3,231.1L127.3,231.1c-3.8,0-7.2-3.1-7.6-6.9l-2-20.1c-0.4-3.8,2.4-6.9,6.2-6.9h0 c3.8,0,7.2,3.1,7.6,6.9l2,20.1C133.9,228,131.1,231.1,127.3,231.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M177.1,231.1L177.1,231.1c-3.8,0-7.2-3.1-7.6-6.9l-2-20.1c-0.4-3.8,2.4-6.9,6.2-6.9h0 c3.8,0,7.2,3.1,7.6,6.9l2,20.1C183.6,228,180.9,231.1,177.1,231.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M226.8,231.1L226.8,231.1c-3.8,0-7.2-3.1-7.6-6.9l-2-20.1c-0.4-3.8,2.4-6.9,6.2-6.9h0 c3.8,0,7.2,3.1,7.6,6.9l2,20.1C233.4,228,230.6,231.1,226.8,231.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M257.7,435.4H72.1c-2.4,0-4.4-2-4.4-4.4l0,0c0-2.4,2-4.4,4.4-4.4h185.6c2.4,0,4.4,2,4.4,4.4l0,0 C262.1,433.5,260.1,435.4,257.7,435.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#DC5455",
    cx: 449.1,
    cy: 254.9,
    r: 23.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M467.7,232.8L467.7,232.8c1.2,0.8,2.7,0.4,3.5-0.7l2.7-4.2c0.8-1.2,0.4-2.7-0.7-3.5l0,0 c-1.2-0.8-2.7-0.4-3.5,0.7l-2.7,4.2C466.2,230.5,466.6,232,467.7,232.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M475.8,239.1L475.8,239.1c0.5,1.3,1.9,1.9,3.2,1.4l4.7-1.8c1.3-0.5,1.9-1.9,1.4-3.2l0,0 c-0.5-1.3-1.9-1.9-3.2-1.4l-4.7,1.8C475.9,236.4,475.3,237.8,475.8,239.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M476.5,249.8L476.5,249.8c-0.1,1.4,1,2.6,2.3,2.7l5,0.3c1.4,0.1,2.6-1,2.7-2.3l0,0c0.1-1.4-1-2.6-2.3-2.7 l-5-0.3C477.8,247.4,476.6,248.4,476.5,249.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M447.2,267.3c-0.8,0-1.5-0.3-2-0.8l-8.5-8.5c-1.1-1.1-1.1-2.9,0-4s2.9-1.1,4,0l5.9,5.9l9.5-16.7 c0.8-1.4,2.5-1.8,3.9-1.1c1.4,0.8,1.8,2.5,1.1,3.9l-11.4,19.9c-0.4,0.8-1.2,1.3-2.1,1.4C447.4,267.3,447.3,267.3,447.2,267.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 444.5,
    cy: 133.9,
    r: 10.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 266.4,
    cy: 150.2,
    r: 4.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 6.3,
    cy: 269.9,
    r: 6.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M439.5,426.7h-18.8c-1.7,0-3.1-1.4-3.1-3.1v0c0-1.7,1.4-3.1,3.1-3.1h18.8c1.7,0,3.1,1.4,3.1,3.1v0 C442.6,425.3,441.2,426.7,439.5,426.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M411.9,437.9h-10c-1.7,0-3.1-1.4-3.1-3.1v0c0-1.7,1.4-3.1,3.1-3.1h10c1.7,0,3.1,1.4,3.1,3.1v0 C415,436.5,413.6,437.9,411.9,437.9z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/Support.5729f19aa161530a86ec6ea1d876bab2.svg";
export { ForwardRef as ReactComponent };